// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"72":"917b08a5","195":"94962409","271":"8f90fc3e","375":"a81514da","383":"5f718893","413":"9694865b","593":"dcc61b0f","661":"2f95a643","678":"3d5c8e38","711":"861d60e2","789":"d70e908a","820":"616be45e","838":"32c02e15"}[chunkId] + ".css";
};